import { createContext } from 'react';
import { DashboardContextProps } from './DashboardContext.types';

// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const DashboardContext = createContext<DashboardContextProps>(undefined);

export default DashboardContext;
